import React from 'react';

import cn from 'utils/classNames';

export const NavbarList = ({ className, children }) => {
  return <nav className={cn(className, 'flex')}>{children}</nav>;
};
